import {Controller, useFormContext} from "react-hook-form";
import {Radio} from "antd";
import {FormField} from "../../../../../design-system/form-field";
import {LiveEventAttendeesFormFieldsType} from "../types";

export function LiveEventAttendeesTypeFormField() {
  const {control, clearErrors, setValue} =
    useFormContext<LiveEventAttendeesFormFieldsType>();
  return (
    <FormField
      id="attendeesType"
      label="Number of attendees"
      renderInput={(id) => (
        <Controller
          control={control}
          name="attendeesType"
          render={({field: {onChange, value, name, onBlur, ref}}) => (
            <Radio.Group
              id={id}
              name={name}
              value={value}
              onChange={(e) => {
                if (e.target.value === "unlimited") {
                  setValue("attendees", -1);
                }
                clearErrors("attendees");
                onChange(e.target.value);
              }}
              onBlur={onBlur}
              ref={ref}
            >
              <Radio value={"limited"}>Limited</Radio>

              <Radio value={"unlimited"}>Unlimited</Radio>
            </Radio.Group>
          )}
        />
      )}
    />
  );
}
